var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6C22 6.26522 21.8946 6.51957 21.7071 6.70711C21.5196 6.89464 21.2652 7 21 7H3C2.73478 7 2.48043 6.89464 2.29289 6.70711C2.10536 6.51957 2 6.26522 2 6V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.032C2 11.7668 2.10536 11.5124 2.29289 11.3249C2.48043 11.1374 2.73478 11.032 3 11.032H21C21.2652 11.032 21.5196 11.1374 21.7071 11.3249C21.8946 11.5124 22 11.7668 22 12.032C22 12.2972 21.8946 12.5516 21.7071 12.7391C21.5196 12.9266 21.2652 13.032 21 13.032H3C2.73478 13.032 2.48043 12.9266 2.29289 12.7391C2.10536 12.5516 2 12.2972 2 12.032V12.032Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.064C2.73478 17.064 2.48043 17.1694 2.29289 17.3569C2.10536 17.5444 2 17.7988 2 18.064C2 18.3292 2.10536 18.5836 2.29289 18.7711C2.48043 18.9586 2.73478 19.064 3 19.064H21C21.2652 19.064 21.5196 18.9586 21.7071 18.7711C21.8946 18.5836 22 18.3292 22 18.064C22 17.7988 21.8946 17.5444 21.7071 17.3569C21.5196 17.1694 21.2652 17.064 21 17.064H3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.9f8ee3f9a352bd1c9f14673afc24efbc.svg";
export { ForwardRef as ReactComponent };